import {
  MAINTENANCE_TYPE_LABELS,
  type MaintenanceType,
} from '@/modules/maintenance/types/maintenance';

type MaintenanceTypeBadgeProps = {
  type: MaintenanceType;
};

export function MaintenanceTypeBadge({ type }: MaintenanceTypeBadgeProps) {
  return (
    <span className="status-badge status-badge--maintenance">
      {MAINTENANCE_TYPE_LABELS[type]}
    </span>
  );
}
